(() => {
  const init = root => {
    if (root.dataset.splReady) return;
    root.dataset.splReady = 'true';
    const variant = root.querySelector('[data-spl-main-variant]');
    const form = variant?.closest('form');
    let selectedOil = null;
    const mainButton = form?.querySelector('[data-spl-add-main]');
    const mainButtonLabel = mainButton?.textContent;
    const selectedOilLabel = root.querySelector('[data-spl-selected-oil]');
    const removeOilButton = root.querySelector('[data-spl-remove-oil]');
    const syncOil = () => {
      if (!mainButton || !selectedOilLabel) return;
      mainButton.textContent = selectedOil ? 'Add diffuser + selected oil to cart' : mainButtonLabel;
      selectedOilLabel.textContent = selectedOil ? `Optional add-on: ${selectedOil.name} — ${selectedOil.price}. One-time purchase at the displayed price.` : 'Device only. Scent oil is optional.';
      removeOilButton.hidden = !selectedOil;
    };
    const emit = (name, data) => window.SleekJourney?.publish?.(name, data);
    const trackProps = role => ({ _sleek_journey: root.dataset.sleekJourney, _sleek_product_role: role, _sleek_landing_page: location.pathname });
    const add = async (items, button, status) => {
      if (button.disabled) return;
      button.disabled = true;
      if (status) status.textContent = 'Adding to your cart…';
      try {
        const route = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${route}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'We could not add that item. Please try again.');
        emit('cart_add_confirmed', { variant_ids: items.map(i => String(i.id)), product_role: items[0].properties._sleek_product_role });
        if (status) status.textContent = 'Added. Opening your cart…';
        location.assign(`${route}cart`);
      } catch (error) {
        if (status) status.textContent = error.message;
        button.disabled = false;
      }
    };
    variant?.addEventListener('change', () => { root.querySelector('[data-spl-price]').textContent = variant.selectedOptions[0].dataset.price; emit('variant_selected', { variant_id: variant.value }); });
    form?.addEventListener('submit', event => {
      event.preventDefault();
      const items = [{ id: variant.value, quantity: 1, properties: trackProps('main') }];
      if (selectedOil) items.push({ id: selectedOil.id, quantity: 1, properties: trackProps('optional-oil') });
      add(items, mainButton, root.querySelector('[data-spl-status]'));
    });
    root.querySelectorAll('[data-spl-add-oil]').forEach(button => button.addEventListener('click', () => {
      const select = button.closest('.spl-scent').querySelector('[data-spl-oil-variant]');
      const option = select.selectedOptions[0];
      selectedOil = { id: select.value, name: option.dataset.name, price: option.dataset.price };
      root.querySelectorAll('[data-spl-add-oil]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      syncOil();
      emit('scent_addon_selected', { variant_id: selectedOil.id });
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    root.querySelectorAll('[data-spl-oil-variant]').forEach(select => select.addEventListener('change', () => {
      const button = select.closest('.spl-scent').querySelector('[data-spl-add-oil]');
      if (button.getAttribute('aria-pressed') === 'true') {
        const option = select.selectedOptions[0];
        selectedOil = { id: select.value, name: option.dataset.name, price: option.dataset.price };
        syncOil();
      }
    }));
    removeOilButton?.addEventListener('click', () => {
      selectedOil = null;
      root.querySelectorAll('[data-spl-add-oil]').forEach(b => b.setAttribute('aria-pressed', 'false'));
      syncOil(); emit('scent_addon_removed', {});
    });
    root.querySelectorAll('[data-spl-add-pet-bundle]').forEach(button => button.addEventListener('click', () => {
      // One native bundle variant requires both components. Never discount a standalone SKU.
      add([{ id: button.dataset.bundleVariant, quantity: 1, properties: trackProps('feeder-fountain-pair') }], button, root.querySelector('[data-spl-addon-status]'));
    }));
    const scent = new URLSearchParams(location.search).get('selected_scent');
    if (['iravyn', 'verdelle', 'blueform'].includes(scent)) {
      const card = root.querySelector(`[data-scent-key="${scent}"]`);
      card?.classList.add('is-highlighted');
      // Highlight an optional add-on only. A paid click never adds products automatically.
      if (card) emit('scent_addon_highlighted', { scent });
    }
  };
  document.querySelectorAll('[data-sleek-product-landing]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sleek-product-landing]').forEach(init));
})();
